<template>
	<div v-if="show">
	
		<label>HHAs per program</label>
		<GChart
			type="ColumnChart"
			:data="chartData"
			:options="chartOptions"
			:events="chartEvents"
			ref="chart"
			@ready="onChartReady"
		/>
	</div>

</template>

<script>
	export default{
		data : function(){
			return {
				show : false,
				chartData : [],
				chartOptions : {
					height: 350,
					chartArea:{width:'100%'},
					colors: ['#215052', '#11a5a7', '#ededed'],
				},
				chartEvents : {
					select : () => {
						var selection = this.chart.getSelection();

						console.log(selection);
					}
				},
				chart :null,
				is3D: true,
				
			}
		},

		created : function(){
			this.iniChart();
		},
		methods : {
			iniChart : function(){
				var params = {
					filters : {}
				}
				
					
					
				this.$store.dispatch('getCourses', params).then((res) => {
					this.courses = res.data.data;
					
					var i = 0;
					var coursesData = [
						['Task', 'Test']
					];
					for (i=0; i<this.courses.length;  i++){
						coursesData[i+1] = [this.courses[i].name, 10];
					}
					
					this.chartData = coursesData;
					this.show = true;
				
				}).catch((error) => {
					console.log(error);
				});
			},
			refresh : function(){
				this.iniChart();
			},
			onChartReady : function(chart, google){
				this.chart = chart;
			}
		}
	}
	/*
		getOrganizations : function() {
				var params = {
					filters : {
						page : this.current_page,
						per_page : this.per_page
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					
					this.organizations = res.data.data;

					this.current_page = res.data.meta.current_page;
					this.total_rows = res.data.meta.total;
					this.per_page = parseInt(res.data.meta.per_page);
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				});
			},
	*/
</script>


// WEBPACK FOOTER //
// src/components/charts/LHCSADashboardChart1Component.vue